export enum ColumnValidationErrorCode {
  ColumnToBeRemovedIsUsedAsJoinKey = "COLUMN_TO_BE_REMOVED_IS_USED_AS_JOIN_KEY",
}

export const REASON_CODE_MESSAGES: Record<string, string> = {
  [ColumnValidationErrorCode.ColumnToBeRemovedIsUsedAsJoinKey]:
    "Column is used as a join key in a model relationship",
};
